import React, { useEffect, useState } from "react";

const SearchBar = ({ placeholder, searchValue, setSearchValue, debounceTime = 300 }) => {
  const [inputValue, setInputValue] = useState(searchValue || "");

  // Keep local input in sync when parent searchValue changes
  useEffect(() => {
    setInputValue(searchValue || "");
  }, [searchValue]);

  // Debounce updates to parent to avoid excessive API calls
  useEffect(() => {
    const handler = setTimeout(() => {
      if (typeof setSearchValue === "function") setSearchValue(inputValue);
    }, debounceTime);

    return () => clearTimeout(handler);
  }, [inputValue, debounceTime, setSearchValue]);

  const handleChange = (e) => setInputValue(e.target.value);

  const handleClear = () => {
    setInputValue("");
    // Immediately notify parent so results reset without waiting debounce
    if (typeof setSearchValue === "function") setSearchValue("");
  };

  return (
    <div className="flex gap-2 mr-5 items-center searchBar">
      <input
        type="text"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        className="searchBar-input"
      />
      {inputValue && (
        <button
          aria-label="clear-search"
          onClick={handleClear}
          className="ml-2 px-2 py-1 bg-gray-200 rounded"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default SearchBar;